import { render, staticRenderFns } from "./CollectContactData.vue?vue&type=template&id=435f396c"
import script from "./CollectContactData.vue?vue&type=script&lang=js"
export * from "./CollectContactData.vue?vue&type=script&lang=js"
import style0 from "./CollectContactData.vue?vue&type=style&index=0&id=435f396c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports